import { memo } from 'react';

import { Logo } from 'shared/Logo';

import { Box, Container, LoaderLine } from './styles';

export const LoadingPage = () => {
  return (
    <Container>
      <Box>
        <Logo />
        <LoaderLine>
          <div />
        </LoaderLine>
      </Box>
    </Container>
  );
};

export default memo(LoadingPage);
